import { T } from 'consts/translationKeys'
import { dispatch } from 'store'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import RemoveIcon from 'assets/svgr-icons/Remove.svg'
import { useActiveItems } from '../../hooks/use-active-items'
import { useMemo } from 'react'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { useKeyPressWithConfigs } from 'hooks'

const removeItems = () => {
  dispatch(projectDataThunks.removeTimelineSelectedItems())
}

export const RemoveButton = () => {
  const { activeMediaItems, activeAudioItems } = useActiveItems()
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)
  const isDisabled = useMemo(() => {
    return !activeMediaItems.length && !activeAudioItems.length
  }, [activeMediaItems.length, activeAudioItems.length])

  useKeyPressWithConfigs('delete', removeItems)
  useKeyPressWithConfigs('backspace', removeItems)

  return (
    <ActionButton
      icon={<RemoveIcon />}
      disabled={isDisabled}
      tooltipText={translate(T.DELETE_LABEL)}
      onClick={removeItems}
      title={isMobile ? translate(T.DELETE_LABEL) : undefined}
    />
  )
}
